import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0 mb-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "card card-body mb-0" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "form-group col-sm-12" }
const _hoisted_6 = { class: "navbar-nav overflow-auto flex-row gap-4" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MerchantStores = _resolveComponent("MerchantStores")!
  const _component_ManualPriorities = _resolveComponent("ManualPriorities")!
  const _component_TrafficGroups = _resolveComponent("TrafficGroups")!
  const _component_AdditionalRewardSettings = _resolveComponent("AdditionalRewardSettings")!
  const _component_TraderPayoutPlans = _resolveComponent("TraderPayoutPlans")!
  const _component_RatesManagement = _resolveComponent("RatesManagement")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("ul", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleTabs, ([tab, value]) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: tab,
                    class: "nav-item nav-item-spaced d-lg-block text-nowrap"
                  }, [
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _withModifiers(($event: any) => (_ctx.selectTab(value)), ["prevent"]),
                      class: _normalizeClass(["nav-link tab", {'active': _ctx.currentTab === value}])
                    }, _toDisplayString(_ctx.helper.trans(`routing.tab.${tab}`)), 11, _hoisted_7)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.currentTab === _ctx.Tabs.stores)
        ? (_openBlock(), _createBlock(_component_MerchantStores, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.currentTab === _ctx.Tabs.manualPriorities)
        ? (_openBlock(), _createBlock(_component_ManualPriorities, { key: 1 }))
        : _createCommentVNode("", true),
      (_ctx.currentTab === _ctx.Tabs.trafficGroups)
        ? (_openBlock(), _createBlock(_component_TrafficGroups, { key: 2 }))
        : _createCommentVNode("", true),
      (_ctx.currentTab === _ctx.Tabs.additionalRewardSettings)
        ? (_openBlock(), _createBlock(_component_AdditionalRewardSettings, { key: 3 }))
        : _createCommentVNode("", true),
      (_ctx.currentTab === _ctx.Tabs.traderPayoutPlans)
        ? (_openBlock(), _createBlock(_component_TraderPayoutPlans, { key: 4 }))
        : _createCommentVNode("", true),
      (_ctx.currentTab === _ctx.Tabs.ratesManagement)
        ? (_openBlock(), _createBlock(_component_RatesManagement, { key: 5 }))
        : _createCommentVNode("", true)
    ])
  ]))
}